import { useState, type FormEvent } from "react";
import { api, ApiHatasi } from "../api";
import { Bildirim } from "../ui";
import { Logo, UrunAdi } from "../marka";

export function Giris({
  girdi,
  konakAd,
}: {
  girdi: () => void;
  /** Musterinin kendi panel adresindeysek o kurumun adi */
  konakAd?: string | null;
}) {
  const [eposta, setEposta] = useState("");
  const [parola, setParola] = useState("");
  const [hata, setHata] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);
  // Iki adimli dogrulama acikken parola dogru olsa bile OTURUM ACILMAZ;
  // elde yalnizca ikinci adimi tamamlamaya yarayan kisa omurlu bir bilet olur.
  const [bilet, setBilet] = useState<string | null>(null);
  const [kod, setKod] = useState("");

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setBekliyor(true);
    try {
      const y = await api.giris(eposta.trim(), parola);
      if (y.ikiAdimGerekli && y.bilet) {
        setBilet(y.bilet);
        // Parolayi bellekte tutmaya gerek yok: ikinci adim yalnizca bileti kullanir.
        setParola("");
      } else {
        girdi();
      }
    } catch (h) {
      // Kullaniciya hangi alanin yanlis oldugu SOYLENMEZ — hesap sayimini kolaylastirir.
      setHata(h instanceof ApiHatasi ? h.message : "Giriş yapılamadı");
    } finally {
      setBekliyor(false);
    }
  }

  async function ikinciAdim(e: FormEvent) {
    e.preventDefault();
    setHata(null);
    setBekliyor(true);
    try {
      await api.ikiAdimGiris(bilet!, kod.trim());
      girdi();
    } catch (h) {
      setHata(h instanceof ApiHatasi ? h.message : "Kod doğrulanamadı");
      // Sure dolduysa bastan basla
      if (h instanceof ApiHatasi && h.durum === 401 && h.message.includes("süre")) {
        setBilet(null);
        setKod("");
      }
    } finally {
      setBekliyor(false);
    }
  }

  if (bilet) {
    return (
      <div className="giris-sayfa">
        <form className="giris-kutu" onSubmit={ikinciAdim}>
          <div className="marka">
            <Logo boyut={26} />
            {konakAd ? <span className="konak-ad">{konakAd}</span> : <UrunAdi />}
          </div>
          <h1>Doğrulama</h1>
          <p className="alt">Doğrulama uygulamanızdaki 6 haneli kodu yazın.</p>

          {hata && <Bildirim tur="kotu">{hata}</Bildirim>}

          <label className="alan">
            <span>Kod</span>
            <input
              value={kod}
              onChange={(e) => setKod(e.target.value.replace(/[^0-9A-Za-z-]/g, "").slice(0, 11))}
              inputMode="numeric"
              autoComplete="one-time-code"
              placeholder="123456"
              required
              autoFocus
              style={{ letterSpacing: "0.18em", fontSize: 18, textAlign: "center" }}
            />
            <small>Telefonunuz yanınızda değilse yedek kodlarınızdan birini yazabilirsiniz.</small>
          </label>

          <button className="dugme ana" disabled={bekliyor || kod.length < 6}>
            {bekliyor ? "Doğrulanıyor…" : "Doğrula"}
          </button>

          <p className="giris-dip">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setBilet(null);
                setKod("");
                setHata(null);
              }}
            >
              ← Başa dön
            </a>
          </p>
        </form>
      </div>
    );
  }

  return (
    <div className="giris-sayfa">
      <form className="giris-kutu" onSubmit={gonder}>
        <div className="marka">
          <Logo boyut={26} />
          <UrunAdi />
        </div>
        <h1>Yönetim paneli</h1>
        <p className="alt">Hesabınızla giriş yapın.</p>

        {hata && <Bildirim tur="kotu">{hata}</Bildirim>}

        <label className="alan">
          <span>E-posta</span>
          <input
            type="email"
            value={eposta}
            onChange={(e) => setEposta(e.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </label>
        <label className="alan">
          <span>Parola</span>
          <input
            type="password"
            value={parola}
            onChange={(e) => setParola(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        <button className="dugme ana" disabled={bekliyor}>
          {bekliyor ? "Giriş yapılıyor…" : "Giriş yap"}
        </button>

        <p className="giris-dip">
          Parolanızı bilmiyorsanız kurumunuzun posta yöneticisine başvurun.
          <br />
          <a href="#/durum">Sistem durumu</a>
        </p>
      </form>
    </div>
  );
}
